<ng-container *ngIf="(meeting$ | async) as meeting">
    <div class="link-team-meeting-directive"
         *ngIf="(meetingUrl$ | async) as linkObject">
        <span adaptTooltip="Meeting"
              class="link-meeting-badge me-1"></span>
        <a [routerLink]="linkObject.path"
           [queryParams]="linkObject.queryParams">{{meeting.name}}</a>
    </div>
</ng-container>
